import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Router, { useRouter } from 'next/router';
import { setImageOptimisationEnabled } from '../constants/imageCdn';

import {
  checkUserIsIdentified,
  getSegmentClient,
  initGA,
  trackPageViewed,
} from '../modules/analytics';
import { useSession } from '../hooks/useSession';

import { trackEvent } from '../modules/analytics';
import { PAGE_SCROLLED } from '../constants/analytics';

import { initDatadogRum } from '../modules/monitoring';
import { parseQueryString } from '../helpers/parseQueryString';
import { getAbsoluteUrl } from '@/helpers/formatUrl';

Router.events.on('routeChangeComplete', url => trackPageViewed(url));

const App = ({ Component, pageProps }) => {
  setImageOptimisationEnabled(
    process.env.NEXT_PUBLIC_IMAGE_CDN_ENABLED === 'true'
  );

  // Use asPath to get the query params because the query object from useRouter gets updated on a second render (too late for session functionality)
  const { asPath } = useRouter();
  const { query } = parseQueryString(asPath);
  const segment = getSegmentClient();

  useSession({ asPath });

  useEffect(() => {
    initDatadogRum();
  }, []);

  useEffect(() => {
    initGA();

    segment.ready(async () => {
      await checkUserIsIdentified();

      trackPageViewed(window.location.pathname);
    });
  }, [query, segment]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollDepth = Math.round(
        (window.scrollY / (document.body.scrollHeight - window.innerHeight)) *
          100
      );
      if (scrollDepth > 25 && !window.__scrollTracked25) {
        trackEvent(PAGE_SCROLLED, {
          scroll_depth: '25%',
          currentPage: getAbsoluteUrl(window.location.pathname),
        });
        window.__scrollTracked25 = true;
      }
      if (scrollDepth > 50 && !window.__scrollTracked50) {
        trackEvent(PAGE_SCROLLED, {
          scroll_depth: '50%',
          currentPage: getAbsoluteUrl(window.location.pathname),
        });
        window.__scrollTracked50 = true;
      }
      if (scrollDepth > 75 && !window.__scrollTracked75) {
        trackEvent(PAGE_SCROLLED, {
          scroll_depth: '75%',
          currentPage: getAbsoluteUrl(window.location.pathname),
        });
        window.__scrollTracked75 = true;
      }
      if (scrollDepth == 100 && !window.__scrollTracked100) {
        trackEvent(PAGE_SCROLLED, {
          scroll_depth: '100%',
          currentPage: getAbsoluteUrl(window.location.pathname),
        });
        window.__scrollTracked100 = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return <Component {...pageProps} />;
};

App.propTypes = {
  Component: PropTypes.func.isRequired,
  pageProps: PropTypes.object.isRequired,
};

export default App;
